.Main {
    --form-gap: 1.1em;

    color: var(--fg);
    padding: var(--small-space) 0 0 0;
    letter-spacing: 0.02em;
}

.Form {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    grid-gap: var(--form-gap);
}

.Input {
    grid-column: span 2;
    font: inherit;
    color: inherit;
    font-variation-settings: inherit;
    letter-spacing: inherit;
    background: none;
    border: solid 1px currentColor;
    border-radius: 999px;
    height: 3.9em;
    padding: 0 2.4em;
    outline: none;
    width: 100%;
    box-sizing: border-box;
    appearance: none;
}

.Input::placeholder {
    color: inherit;
    opacity: 1;
}

.Input:focus-visible {
    border-color: var(--lilac-dream);
    box-shadow: inset 0 0 0 1px var(--lilac-dream);
}

.prename,
.name,
.zip,
.city {
    grid-column: span 1;
}

.address {
    margin-top: calc(var(--form-gap) * 3);
}

.Memberships {
    grid-column: span 2;
    border: none;
    margin: calc(var(--form-gap) * 3) 0 0 0;
    padding: 0;
    display: grid;
    grid-gap: 0.75em;
}

.Legend {
    display: block;
    width: 100%;
    padding: 0 0 2em 0;
    margin: 0 0 1.75em 0;
    border-bottom: solid 1px currentColor;
}

.Membership {
    display: grid;
    grid-template-columns: max-content minmax(0, 1fr) max-content minmax(2.9em, max-content);
    grid-gap: 1em;
    align-items: center;
    cursor: pointer;
}

.Radio {
    appearance: none;
    width: 1.6em;
    height: 1.6em;
    margin: 0;
    border: solid 1px var(--fg);
    border-radius: 50%;
    cursor: pointer;
}

.Radio:checked {
    background: var(--fg);
    box-shadow: inset 0 0 0 0.25em var(--bg);
}

.Radio:focus-visible {
    outline: solid 1px var(--lilac-dream);
    outline-offset: 2px;
}

.MembershipPrice {
    text-align: right;
    font-variation-settings: "wght" 650;
}

.MembershipDescription {
    text-align: left;
}

.Submit {
    grid-column: 2 / span 1;
    margin-top: calc(var(--form-gap) * 5);
    background: var(--lilac-dream);
    color: var(--black);
    border: none;
    border-radius: 999px;
    height: 3.9em;
    padding: 0 1.5em;
    text-align: center;
}

.Submit:disabled {
    opacity: 0.5;
    cursor: default;
}

.Status {
    grid-column: span 2;
}

.Status:empty {
    display: none;
}

@media (max-width: 767px) {
    .Submit {
        grid-column: span 2;
    }
}

.Success {
    display: none;
    line-height: 1.7;
    outline: none;
}

.Success p {
    padding: 0 0 1.7em 0;
}

.Success > :last-child {
    padding: 0;
}

.Success h2,
.Success h3 {
    font-size: 2em;
    line-height: 1.1;
    padding: 0 0 0.85em 0;
}

.Success strong {
    font-weight: normal;
    font-variation-settings: "wght" 600;
}

.Success a {
    border-bottom: solid 1px currentColor;
}

.IsSent .Form {
    display: none;
}

.IsSent .Success {
    display: block;
}
